var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-icon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lift-2",
    "data-name": "Lift"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 46.37,
    y: 27.48,
    width: 31.32,
    height: 76.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 83.66,
    y: 27.48,
    width: 31.32,
    height: 76.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fill-icon",
    points: "23.99 42.4 15.04 58.81 32.94 58.81 23.99 42.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fill-icon",
    points: "23.99 85.66 15.04 69.25 32.94 69.25 23.99 85.66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift);
export default __webpack_public_path__ + "static/media/lift.8c94838d2f46c4d71a62095a78df303f.svg";
export { ForwardRef as ReactComponent };